import PageTemplateService from '@/component/templates/PageTemplate/_service/PageTemplateService'
import { clsx } from 'clsx'
import useRepository from '@/hooks/useRepository'
import { Icon } from '@design-system/components/atoms'
import { mediaQuery, typo } from '@design-system/styles'
import { css } from '@emotion/react'
import React from 'react'
import { observer } from 'mobx-react'
import colors from '@mathflat/common/style/colors'

const SideNavigationOpenButton = () => {
  const service = useRepository(PageTemplateService)

  return (
    <button
      css={_Style}
      onClick={() => service.setSideNavigationOpen(!service.isSideNavigationOpen)}
    >
      <div className="dot" />
      <div className="button-label">
        <p>메뉴 {service.isSideNavigationOpen ? '닫기' : '열기'}</p>
      </div>
      <Icon
        className={clsx('chevron_double_right', service.isSideNavigationOpen && 'open')}
        name="chevron_double_right"
        size={10}
        color={colors.gray.$700}
      />
    </button>
  )
}

export default observer(SideNavigationOpenButton)

const _Style = css`
  position: absolute;
  display: none;
  align-items: center;
  width: 112px;
  height: 28px;
  padding: 0 12px;
  border-radius: var(--Radius-300);
  background-color: var(--Colors-Gray-100);

  ${mediaQuery.large} {
    display: flex;
  }

  .dot {
    min-width: 7px;
    height: 7px;
    border-radius: var(--Radius-Circle);
    background-color: ${colors.gray.$400};
  }

  .button-label {
    display: flex;

    p {
      ${typo.caption01}
      margin: 0 6px;
      margin-top: 2px;
      color: ${colors.gray.$800};
    }
  }

  .chevron_double_right {
    margin-left: auto;
    min-width: 10px;

    &.open {
      transform: rotate(180deg);
    }
  }
`
